import { howItWorks } from '@/mocks/content';

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            {howItWorks.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {howItWorks.steps.map((step, index) => (
            <div key={step.number} className="text-center relative">
              {/* Number */}
              <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
                <span className="font-heading text-2xl font-bold">{step.number}</span>
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-2">
                {step.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {step.description}
              </p>

              {/* Connector arrow between steps */}
              {index < 2 && (
                <div className="hidden md:block absolute top-8 left-[calc(50%+40px)] w-[calc(100%-80px)]">
                  <div className="border-t-2 border-dashed border-background-300"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}